import { NgModule } from '@angular/core';
import { EnvironmentsRotatorComponent} from './environmentsRotator'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule } from '@angular/forms';
import {SchemaItemModule} from '../../../../schema-item/schema-item.module'
import {SchemaConnectorModule} from '../../../../schema-connector/schema-connector.module'


@NgModule({
    imports: [ FormsModule,BrowserModule,SchemaItemModule,SchemaConnectorModule],
    declarations: [
        // EnvironmentItemComponent,
        EnvironmentsRotatorComponent
    ],
    entryComponents: [
        EnvironmentsRotatorComponent
    ],
    exports: [
        EnvironmentsRotatorComponent
    ]
})
export class EnvironmentsRotatorModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/environmentsRotator/environmentsRotator.module.ts